module.exports = __webpack_public_path__ + "img/create-head.47071c4c.svg";